import styled, { css } from 'styled-components';

const MOBILE_BORDER_RADIUS = 34;

const isTopExpandDirection = (expandDirection: 'top' | 'bottom') => {
	return expandDirection === 'top';
};

const isBottomExpandDirection = (expandDirection: 'top' | 'bottom') => {
	return expandDirection === 'bottom';
};

const isLeftHorizontalDirection = (horizontalDirection: 'left' | 'right') => {
	return horizontalDirection === 'left';
};

const isRightHorizontalDirection = (horizontalDirection: 'left' | 'right') => {
	return horizontalDirection === 'right';
};

export const OptionsListContainer = styled.div<{
	$expandDirection: 'top' | 'bottom';
	$horizontalDirection: 'left' | 'right';
}>`
	${({ theme, $expandDirection, $horizontalDirection }) => css`
		min-width: 214px;
		height: auto;
		background-color: #ffffff;

		border-radius: ${isBottomExpandDirection($expandDirection) &&
			isLeftHorizontalDirection($horizontalDirection)
		? 0
		: MOBILE_BORDER_RADIUS}px
			${isBottomExpandDirection($expandDirection) && isRightHorizontalDirection($horizontalDirection)
		? 0
		: MOBILE_BORDER_RADIUS}px
			${isTopExpandDirection($expandDirection) && isRightHorizontalDirection($horizontalDirection)
		? 0
		: MOBILE_BORDER_RADIUS}px
			${isTopExpandDirection($expandDirection) && isLeftHorizontalDirection($horizontalDirection)
		? 0
		: MOBILE_BORDER_RADIUS}px;
		box-shadow: ${theme.shadows.base};
		padding: 24px 35px;

		@media ${theme.screens.screenL} {
			border-radius: 3px;
			padding: 6px;
		}
	`}
`;

export const OptionContainer = styled.div`
	${({ theme }) => css`
		font-size: ${theme.fontSizes.s};
		font-weight: ${theme.fontWeights.regular};

		&:hover {
			color: ${theme.colors.brand.primary[300]};
			background-color: ${theme.colors.brand.primary.background};
		}

		@media ${theme.screens.screenL} {
			padding: 8px;
		}
	`}
`;
